module.exports = __webpack_public_path__ + "img/公安檢查人(防火避難類).3a3122e3.jpg";